import React, {useContext} from "react";
import {Context} from "../../index";
import {GeoPicker} from "../GeoPicker";
import {User} from "../User";
import {PaneMenu} from "../PaneMenu";

import styles from "./pane.module.scss";

export function Pane() {
  const {user} = useContext(Context);
  const isLogged = !!user.name;

  return (
    <div className={styles.pane}>
      <GeoPicker />
      <ul className={styles.menu}>
        <PaneMenu />
        {isLogged ? (
          <li>
            <User />
          </li>
        ) : (
          <>
            <li>
              <a href="/sign_in">Войти</a>
            </li>
            <li>
              <a href="/sign_up">Регистрация</a>
            </li>
          </>
        )}
      </ul>
    </div>
  );
}
